export const ACCESSION_EDIT_ACCESSION = "@@accession/ACCESSION_EDIT_ACCESSION";
export const ACCESSION_ADD_SPECIMEN = "@@accession/ACCESSION_ADD_SPECIMEN";
export const ACCESSION_EDIT_SPECIMEN = "@@accession/ACCESSION_EDIT_SPECIMEN";

export const noClinicalHistoryString = "No Clinical History provided.";
export const noClinicalHistoryClinicString =
  "No Clinical History provided by the clinic";
export const clinicalHistoryNotEnteredString =
  "Clinical history not yet entered";

export const SPECIMEN_BAG_SCAN = "@@accession/SPECIMEN_BAG_SCAN";
